import React, { PureComponent } from "react";
import { Col } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import renderSelectField from "../../../../shared/components/form/Select";
import * as configs from "./config";
import ReactTags from "react-tag-autocomplete";

class HorizontalForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {};

  componentDidMount() {
    this.props.initialize(this.props.edit());
    this.setState(this.props.edit(), () => {
      this.props.handleForm(this.state);
    });
    this.useCaseRef = React.createRef();
    this.tagRef = React.createRef();
  }

  cancelCreation = () => {
    this.props.reset();
    this.props.cancelCreation();
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {
      this.props.handleForm(this.state);
    });
  };

  formConnectionHandler = (event) => {
    this.setState({ online: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  formTypeConnectionHandler = (event) => {
    this.setState({ type: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  getCaseSuggestions = () => {
    return configs.useCases;
  };

  getTags = () => {
    return configs.tags;
  };

  getOptions = (key) => {
    switch (key) {
      case "online":
        return configs.statuses;
      case "type":
        return configs.types;
      case "lid":
        let locations = [];
        this.props.nodes.forEach((node) => {
          locations.push({ value: node.lid, label: node.name });
        });
        return locations;
      default:
        return [];
    }
  };

  printInput = (input) => {
    switch (input.key) {
      case "lid":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={this.getOptions(input.key)}
            onChange={(event) => {
              this.setState({ lid: event.value }, () => {
                this.props.handleForm(this.state);
              });
            }}
          />
        );
      case "online":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={this.getOptions(input.key)}
            onChange={this.formConnectionHandler}
          />
        );
      case "type":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={this.getOptions(input.key)}
            onChange={this.formTypeConnectionHandler}
          />
        );
      case "use_cases":
        return (
          <ReactTags
            ref={this.useCaseRef}
            tags={this.state.use_cases}
            allowNew="true"
            suggestions={this.getCaseSuggestions()}
            onDelete={this.onDelete.bind(this, input.key)}
            onAddition={this.onAddition.bind(this, input.key)}
            placeholderText="Add Use Case"
            addOnBlur="true"
          />
        );
      case "tags":
        return (
          <ReactTags
            ref={this.tagRef}
            tags={this.state.tags}
            allowNew="true"
            suggestions={this.getTags()}
            onDelete={this.onDelete.bind(this, input.key)}
            onAddition={this.onAddition.bind(this, input.key)}
            placeholderText="Add Tag"
            addOnBlur="true"
          />
        );
      default:
        return (
          <Field
            name={input.key}
            component="input"
            type="text"
            placeholder={input.name}
            onKeyUp={this.formChangeHandler}
          />
        );
    }
  };

  onDelete(key, i) {
    switch (key) {
      case "use_cases":
        const use_cases = this.state.use_cases.slice(0);
        use_cases.splice(i, 1);
        this.setState({ use_cases }, () => {
          this.props.handleForm(this.state);
        });
        break;
      case "tags":
        const tags = this.state.tags.slice(0);
        tags.splice(i, 1);
        this.setState({ tags }, () => {
          this.props.handleForm(this.state);
        });
        break;
      default:
        return [];
    }
  }

  onAddition(key, tag) {
    switch (key) {
      case "use_cases":
        const use_cases = [].concat(this.state.use_cases, tag);
        this.setState({ use_cases }, () => {
          this.props.handleForm(this.state);
        });
        break;
      case "tags":
        const tags = [].concat(this.state.tags, tag);
        this.setState({ tags }, () => {
          this.props.handleForm(this.state);
        });
        break;
      default:
        break;
    }
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <Col md={12} lg={12}>
        <div className="card__title">
          <h5 className="bold-text">{this.props.title}</h5>
        </div>
        <form autoComplete="off" className="form form--horizontal" onSubmit={handleSubmit}>
          {configs.columnHeader.map((input) =>
            !input.system ? (
              <div className="form__form-group">
                <span className="form__form-group-label">{input.name}</span>
                <div className="form__form-group-field">
                  {this.printInput(input)}
                </div>
              </div>
            ) : (
              ""
            )
          )}
        </form>
      </Col>
    );
  }
}

export default reduxForm({
  form: "add_subnet_form", // a unique identifier for this form
})(HorizontalForm);
